// Piano Analytics Constants
export const PIANO_EVENTS = {
  PAGE_DISPLAY: 'page.display',
  PURCHASE: 'purchase',
  USER_IDENTIFICATION: 'user.identification',
} as const;

export const PIANO_DEVICE_PROPERTIES = {
  DEVICE_TIMESTAMP_UTC: 'device_timestamp_utc',
  EVENT_COLLECTION_PLATFORM: 'event_collection_platform',
  EVENT_COLLECTION_VERSION: 'event_collection_version',
  DEVICE_DISPLAY_HEIGHT: 'device_display_height',
  DEVICE_DISPLAY_WIDTH: 'device_display_width',
  DEVICE_SCREEN_HEIGHT: 'device_screen_height',
  DEVICE_SCREEN_WIDTH: 'device_screen_width',
  DEVICE_OS: 'device_os',
  DEVICE_OS_VERSION: 'device_os_version',
  DEVICE_TYPE: 'deviceType',
  DEVICE_MANUFACTURER: 'device_manufacturer',
  PLATFORM: 'platform',
  DOMAIN: 'domain',
  PREVIOUS_URL: 'previous_url',
} as const;

export const PIANO_DEVICE_OS = {
  IOS: 'ios',
  ANDROID: 'android',
  WINDOWS: 'windows',
  MACOS: 'macos',
  LINUX: 'linux',
  UNKNOWN: 'unknown',
} as const;

export const PIANO_DEVICE_TYPES = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop',
} as const;

export const PIANO_PLATFORMS = {
  IOS: 'iOS',
  ANDROID: 'Android',
  WINDOWS: 'Windows',
  MACOS: 'macOS',
  LINUX: 'Linux',
  WEB: 'Web',
} as const;

export const PIANO_USER_PROPERTIES = {
  USER: 'user',
  SESSION: 'session',
  ACCOUNT: 'account',
} as const;

export const PIANO_EVENT_PROPERTIES = {
  EVENT: 'event',
  TIME: 'time',
  USER_ID: 'user_id',
  PAGE_URL: 'page_url',
  PAGE_TITLE: 'page_title',
} as const;

export const PIANO_HTTP_CONFIG = {
  METHOD: 'POST',
  CONTENT_TYPE: 'text/plain',
} as const;

export const PIANO_COLLECTION_PLATFORM = {
  API: 'api',
  VERSION: '2',
} as const;

export const PIANO_STORAGE_KEYS = {
  SESSION_ID: 'piano_session_id',
} as const;

export const PIANO_DEVICE_MANUFACTURERS = {
  IPHONE: 'iPhone',
  ANDROID: 'Android',
  UNKNOWN: 'Unknown',
} as const;

export const PIANO_USER_AGENT_PATTERNS = {
  IOS: /iPhone|iPad|iPod/,
  ANDROID: /Android/,
  WINDOWS: /Windows/,
  MAC: /Mac/,
  LINUX: /Linux/,
  MOBILE: /Mobile|Android|iPhone|iPad/,
  TABLET: /Tablet|iPad/,
  OS_VERSION: /OS (\d+)_(\d+)_?(\d+)?/,
} as const;
